import { createAction, props } from '@ngrx/store';

import { ErrorActionPayload, RecordsPageResultActionPayload } from '@bp/shared/models/common';
import { Entity, FirebaseEntity } from '@bp/shared/models/metadata';

import { EntitiesApiActions } from './entities-api.actions';

export function composeEntitiesListApiActions<TEntity extends Entity | FirebaseEntity>(
	scope: string,
): EntitiesApiActions<TEntity> {
	return {
		loadSuccess: createAction(
			`${ scope } Load Success`,
			props<RecordsPageResultActionPayload<TEntity>>(),
		),

		loadFailure: createAction(
			`${ scope } Load Failure`,
			props<ErrorActionPayload>(),
		),

		loadAllSuccess: createAction(
			`${ scope } Load All Success`,
			props<RecordsPageResultActionPayload<TEntity>>(),
		),

		loadAllFailure: createAction(
			`${ scope } Load All Failure`,
			props<ErrorActionPayload>(),
		),
	};
}
